import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppConstants } from '../../constants/app.constants';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { AppAuthNService, User } from '../../../services/app-auth-n.service';
import { environment } from '../../../../environments/environment';
import { UserService } from '../../../services/user.service';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {


  @ViewChild('confirmModal', { static: false })
  confirmModal: ModalDirective;

  isCollapsed: boolean = true;
  isAuthorizedSubscription: Subscription;
  isAuthorized: boolean = false;

  tituloConfirmCerrarSesion: string = AppConstants.TituloModal.TITULO_CONFIRM_CERRAR_SESION;
  preguntaCerrarSesion: string = AppConstants.QuestionModal.QUESTION_CERRAR_SESION;
  isNavRipley: boolean = false;
  currentUser: User;
  isFirstSubNavRipley: boolean = false;
  isSecondSubNavRipley: boolean = false;
  icons = [];
  reportIcons = [];

  arrayOpciones = [];
  constantes = AppConstants;
  modules = [];
  ableOptions = [
    [1, 2, 3, 4, 5, 6, 7, 8],
    [1]
  ];

  userName = "";
  idUser: number = 0;

  idleState = 'Timeout detenido.';
  timedOut = false;
  lastPing?: Date = null;
  dlgTimeout: boolean = false;

  constructor(
    public authn: AppAuthNService,
    public router: Router,
    public userService: UserService,
    private idle: Idle,
    private keepalive: Keepalive
  ) {
    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(5);//600
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(600);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onIdleEnd.subscribe(() => {
      this.idleState = 'Reiniciando Timeout...';
    });
    idle.onTimeout.subscribe(() => {
      this.idleState = 'Timed out!';
      this.timedOut = true;
      this.logout();
    });
    idle.onIdleStart.subscribe(() => {
      this.idleState = 'Timeout iniciado!';
    });
    idle.onTimeoutWarning.subscribe((countdown) => {
      this.idleState = 'Su sesión se cerrará en ' + countdown + ' segundos!';
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);
    keepalive.onPing.subscribe(() => {
      this.lastPing = new Date();
    });

    this.reset();
  }

  reset() {
    this.idle.watch();
    this.idleState = 'Timeout iniciado!';
    this.timedOut = false;
    //this.dlgTimeout = false;
  }

  ngOnInit() {
    this.authn.getUser().then(user => {
      this.currentUser = user;
      if (user) {
        this.isAuthorized = true;
      }
    }).catch(err => { });

    if (localStorage.getItem("userApplicationData")) {
      var data = JSON.parse(localStorage.getItem("userApplicationData"));

      if (data && data.username) {
        this.userName = data.username;
        this.idUser = data.id;
      }
    }

    this.cargarMenu();
  }

  logoutModal() {
    this.confirmModal.show();
  }

  close() {
    this.confirmModal.hide();
  }

  showNav() {
    this.isNavRipley = !this.isNavRipley;
  }

  hideNav() {
    this.isNavRipley = !this.isNavRipley;
    this.hideSubNavs();
  }

  cargarMenu() {
    this.cargarIcons();
    if (localStorage.getItem("userApplicationData")) {
      let data = JSON.parse(localStorage.getItem("userApplicationData"));
      data.modules.forEach(modulo => {
        this.putLinkToOption(modulo.options);
        modulo.options.forEach(option => this.putIconToOption(option));
        modulo.show = false;
        this.modules.push(modulo);
      });
    }
  }

  showModule(modulecode) {
    this.modules.forEach(modulo => {
      if (modulo.modulecode == modulecode) {
        modulo.show = true;
      }
      else {
        modulo.show = false;
      }
    });
  }

  hideModule() {
    this.modules.forEach(modulo => {
      modulo.show = false;
    });
  }

  cargarIcons() {
    this.icons = [
      { name: "cog", animation: "", codeOptions: [2] },
      { name: "wrench", animation: "", codeOptions: [1] },
    ]
  }

  cargarReportIcons() {
    this.reportIcons = [
      { name: "cog", animation: "spin", codeOptions: [1, 2] }
    ]
  }

  putIconToOption(option: any) {
    let icon = this.icons.filter(icon => icon.codeOptions.includes(option.optioncode)).pop();
    option.icon = icon;
  }
  putReportIconToOption(option: any) {
    let icon = this.reportIcons.filter(icon => icon.codeOptions.includes(option.optioncode)).pop();
    option.icon = icon;
  }

  putLinkToOption(options: any[]) {
    options.forEach(option => {
      switch (option.optioncode) {
        case 1:
          option.link = "/clients-list";
          break;
        case 2:
          option.link = "/models-list";
          break;
        case 3:
          option.link = "/template-list";
          break;
        case 7:
          option.link = "/ordersales-gcv-step1-list";
          break;
        case 8:
          option.link = "/ordersales-gcv-step2-list";
          break;
        case 9:
          option.link = "/ordersales-gcv-step3-list";
          break;
        case 10:
          option.link = "/ordersales-gcv-step4-list";
          break;
        case 11:
          option.link = "/ordersales-gcv-step5-list";
          break;
        case 17:
          option.link = "/ordersales-gcv-monitoring";
          break;
        case 12:
          option.link = "/ordersales-gcf-step1-list";
          break;
        case 13:
          option.link = "/ordersales-gcf-step2-list";
          break;
        case 15:
          option.link = "/ordersales-gcf-step3-list";
          break;
        case 16:
          option.link = "/ordersales-gcf-step4-list";
          break;
        case 18:
          option.link = "/ordersales-gcf-monitoring";
          break;
        case 23:
          option.link = "/cac-consult";
          break;
        case 24:
          option.link = "/rpt-saldo";
          break;
        case 25:
          option.link = "/rpt-activacion";
          break;
        case 28:
          option.link = "/ordersales-tv-step1-list";
          break;
        case 29:
          option.link = "/ordersales-tv-step2-list";
          break;
        case 30:
          option.link = "/ordersales-tv-monitoring";
          break;
        default:
          option.link = "/";
          break;
      }
    });
  }

  putLinkToReportOption(options: any[]) {
    options.forEach(option => {
      switch (option.optioncode) {
        case 1:
          option.link = "/reporte";
          break;
        case 2:
          option.link = "/reporteAccesos";
          break;
      }
    });
  }

  showFirstSubNavVisibility() {
    this.isFirstSubNavRipley = true;
    this.isSecondSubNavRipley = false;
  }

  hideFirstSubNavVisibility() {
    this.isFirstSubNavRipley = false;
  }

  showSecondSubNavVisibility() {
    this.isSecondSubNavRipley = true;
    this.isFirstSubNavRipley = false;
  }

  hideSecondSubNavVisibility() {
    this.isSecondSubNavRipley = false;
  }

  hideSubNavs() {
    this.hideFirstSubNavVisibility();
    this.hideSecondSubNavVisibility();
    this.hideModule();
  }

  busquedaObjetoModule(array, code: number) {
    for (var i = 0; i < array.length; i++) {
      if (array[i].modulecode == code) {
        return array[i];
      }
    }

    return null;
  }
  busquedaObjeto(array, options) {
    //debugger;
    for (var i = 0; i < array.length; i++) {
      if (options.includes(array[i].optioncode)) {
        return array[i];
      }
    }

    return null;
  }

  logout() {
    this.router.navigate(['login']);
  }

}
